import React from 'react';
import './styles.scss';

const SearchInput = ({
  placeholder,
  value,
  handleChange
}: {
  placeholder?: string;
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <div className='search__input__container'>
      <input
        type='search'
        className='search__input'
        placeholder={placeholder || 'Search'}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchInput;
